// extracted by mini-css-extract-plugin
export var author = "AuthorAttribution-module--author--ff0fc";
export var authorwrapper = "AuthorAttribution-module--authorwrapper--9bf52";
export var icon = "AuthorAttribution-module--icon--7adaa";
export var label = "AuthorAttribution-module--label--6a5ee";